import React, { useState } from 'react'
import { history } from '../../pages/index';
import Skeleton from "@material-ui/lab/Skeleton";



const WebsiteVideoImageSkeleton = ({ src = '' , alt = ''}) => {
    const [imageLoaded, setImageLoaded] = useState(false);


    const isImageLoaded = (val) =>{
        setImageLoaded(val)
    }

  return (
      <>
      {!imageLoaded &&
        <div style={{position:'absolute',top:'0',left:'0'}}>
            <Skeleton
                animation="wave"
                variant="rectangular"
                width={344}
                height={196}
            />
        </div>
      }
        <img src={src} alt={alt} style={{height: '100%',width: '100%', objectFit: 'cover',}} className={`${imageLoaded ? 'd-block' : 'd-none'}`} onLoad={() => isImageLoaded(true)} />
      </>
  )
}

export default WebsiteVideoImageSkeleton
